import { store } from "../../../applicationState";
import { makeToProductsListViewProps } from "./makeToProductsListViewProps";
import { makeToProductProps } from "./makeToProductProps";

export const toProductsListViewProps = makeToProductsListViewProps(store.dispatch, makeToProductProps(store.dispatch));
